(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    // The gift-box cut switch is not a product option: its change must not reach the variant picker, which
  // would request a variant for it. It shows the colours of the chosen cut instead and selects the same
  // colour there (or the first one), and that selection drives the picker as usual.
  document.addEventListener(
    'change',
    (event) => {
      const cut = event.target;
      if (!(cut instanceof HTMLInputElement) || !('cutSwitch' in cut.dataset)) return;
      event.stopPropagation();

      const prefix = `${cut.value} – `;
      const colours = [...(cut.closest('variant-picker')?.querySelectorAll('input[data-option-name]') ?? [])].filter(
        (input) => input.value.includes(' – ')
      );
      const colour = colours.find((input) => input.checked)?.value.split(' – ')[1];
      for (const input of colours) {
        const label = input.closest('label');
        if (label) label.hidden = !input.value.startsWith(prefix);
      }
      const target =
        colours.find((input) => input.value === prefix + colour) ??
        colours.find((input) => input.value.startsWith(prefix));
      target?.click();
    },
    true
  );
  } catch(e) { console.error(e); }
})();

})();
